/**
 * Webinar Listing Page – Filter Auto-submit
 *
 * Submits the #webinar-filters form automatically whenever a <select> or
 * radio <input> changes. The text search field submits on Enter or via the
 * adjacent submit button (standard browser behaviour — no JS needed there).
 *
 * This module is eagerly loaded on every page via main.js:
 *   import.meta.glob('@/modules/*.js', { eager: true })
 * so we guard against pages that don't have the filter form.
 */

const form = /** @type {HTMLFormElement|null} */ (document.getElementById('webinar-filters'))
if (form) {
    form.addEventListener('change', (e) => {
        const target = /** @type {HTMLElement} */ (e.target)
        if (target.matches('select') || target.matches('input[type="radio"]')) {
            // requestSubmit fires the native submit event (respects validation)
            // and is supported in all modern browsers.
            form.requestSubmit()
        }
    })
}
